<template>

  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="0"
    offset-x
    min-width="230px"
    left="auto"
  >
    <template v-slot:activator="{ on }">
      <v-btn large icon v-on="on">
        <v-icon size="40" color="primary">mdi-brush</v-icon>
      </v-btn>
    </template>
    <v-card>
 <v-list-item class="selector2">
        <v-list-item-content
          ><v-list-item-title class="font-weight-bold">
            Cogneetiv Dark</v-list-item-title
          >
        </v-list-item-content>
        <v-list-item-action
          ><v-switch v-model="$vuetify.theme.dark" />
        </v-list-item-action>
      </v-list-item>
    </v-card> </v-menu
>
</template>

<script>
export default {
  name: "ThemeChanger",
  data: () => ({
   menu:false,
//   theme: {
    themes: {
      dark: {
        primary: "#78cce2",
        primary2: "#3e90a5",
        primary3: "#1e5a6f",
        color: "#1e1e1e",
        accent: "#7CB342",
        secondary: "#0c161b",
        secondary2: "#0c161b",
        secondary3: "#0c161b",
        success: "#4CAF50",
        info: "#6156d8",
        warning: "#1565C0",
        error: "#FF7043",
        nav: "#0c161b",
        bar: "#0c161b",
      },
      light: {
        primary: "#0c161b",
        primary2: "#162831",
        primary3: "#1e5a6f",
        accent: "#a1e754",
        secondary: "#fff",
        secondary2: "#4c5c60",
        secondary3: "#304057",
        success: "#6dff74",
        info: "#304057",
        warning: "#2e8ac0",
        error: "#ff5e3c",
      }
    },
  }),
  methods: {
  }
};
</script>

<style scoped>
.selector2 {
  padding: 5px 14px;
  right: 50;
}

</style>